import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {MedicalMorphologyDataService} from './impl/service/ngrx/medicalMorphologyData.service';
import {MedicalMorphologyRepository} from './impl/service/ngrx/medicalMorphology.repository';
import {
    AI_REALTIME_TOOL_DEFINITIONS,
    AiRealtimeToolDefinition
} from '../../ai/realtime/api/service/aiRealtime.service';

@NgModule({
    providers: [
        {
            provide: AI_REALTIME_TOOL_DEFINITIONS,
            useValue: [
                {
                    toolName: 'add_morphologies_to_consultation',
                    runningLabel: 'Ajout d\'une morphologie en cours',
                    errorLabel: 'Erreur lors de l’ajout de morphologie',
                    successLabel: 'Morphologie(s) ajoutée(s)',
                    appEventNames: ['medicalMorphology']
                } as AiRealtimeToolDefinition],
            multi: true,
        }
    ]
})
export class MedicalMorphologyModule {

    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: MedicalMorphologyDataService,
                service: MedicalMorphologyRepository,
    ) {

        entityDataService.registerServices({
            MedicalMorphology: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalMorphology: service,
        });
    }
}
